// Holds the setup-form draft in sessionStorage so the /check page can
// read it when the user clicks "Begin Interview". sessionStorage clears
// on tab close, which is what we want — abandoning the flow shouldn't
// leak resume text or JD across users on a shared machine.

import type { CreateSessionInput } from "./types"

const STORAGE_KEY = "mock-interview:setup-draft"

export interface MockInterviewDraft extends CreateSessionInput {
  resume_filename?: string | null
}

export function saveDraft(draft: MockInterviewDraft): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft))
  } catch {
    // sessionStorage may be unavailable in private mode — caller is
    // responsible for surfacing a clear error to the user.
  }
}

export function loadDraft(): MockInterviewDraft | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw) as MockInterviewDraft
  } catch {
    return null
  }
}

export function clearDraft(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // swallow
  }
}
